import { render, staticRenderFns } from "./RtsDataTable.vue?vue&type=template&id=1236ee4a&"
import script from "./RtsDataTable.vue?vue&type=script&lang=ts&"
export * from "./RtsDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./RtsDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports